var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNewspaper = function SvgIconNewspaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.125a1 1 0 0 0 0 2h6.75a1 1 0 1 0 0-2zM8.75 13.875a1 1 0 0 1 1-1h6.75a1 1 0 1 1 0 2H9.75a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.991 17.491a.88.88 0 0 0 .259-.619V6A1.75 1.75 0 0 1 6 4.25h14.25A1.75 1.75 0 0 1 22 6v11.25a2.5 2.5 0 0 1-2.5 2.5H3.37m2.88-2.875V6.25H20v11a.5.5 0 0 1-.5.5H6.111c.09-.279.138-.572.139-.87l-1-.005z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37 19.75A2.886 2.886 0 0 1 .5 16.88V8.25a1 1 0 0 1 2 0v8.622a.884.884 0 0 0 .875.878.89.89 0 0 0 .616-.259"
  }))));
};
export default SvgIconNewspaper;